<template>
  <section class="bg-primary">
    <div class="container ">

      <ContentsPageTitle
        title="Mechanical Recycling"
        description="Mechanical recycling of plastics means we keep plastic waste (Post consumer recycle or PCR) from land or sea to sort, wash, dry and crush then mix with virgin plastic into new PCR compounds."
      />

    </div>
  </section>

  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            credit="photo credit : https://recyclinginside.com"
            image-url="/pages/products/sustainable-plastics/recy01.jpg"
            :contents="[
              'Our mechanical recycling has consistent mechanical properties and more color options than standard recycled plastics due to postconsumer recycled product selection that certified by SCS Global service and superior waste management process. Up to 80% of postconsumer recycled (PCR) content can be achieved and up to 60% Co2 reduction.'
            ]"
            is-reverse="true"
            left-width="43.444%"
            right-width="56.275%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/sustainable-plastics/recy02.jpg"
            :contents="[
              'Water bottle, packaging film, sheet, container, consumer products, consumer electronics, auto parts, structural parts, or products to use in extreme temperatures'
            ]"
            left-width="43.421%"
            right-width="56.252%"
          />
        </div>

      </div>


    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :partners="[
            {
              name: 'Sabic',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/sustainable-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'Mechanical Recycling - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>
